import { useLanguage } from '../LanguageContext';

export default function DayFullPage({ image, titleKey }) {
  const { t } = useLanguage();

  return (
    <div className="relative w-full h-full min-h-[calc(100vh-160px)] flex flex-col items-center justify-center overflow-hidden rounded-lg">
      <img
        src={image}
        alt="Cover"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent" />
      <div className="relative z-10 px-8 text-center">
        <h2 className="text-white text-banner-title text-6xl">
          {t(titleKey)}
        </h2>
      </div>
    </div>
  );
}
